import { getApiClient } from './authApiClient';
import { getSupportPreviewUserId } from '../utils/supportPreview';

const base = tenantId => {
  if (typeof tenantId !== 'string' || !tenantId.trim()) throw new Error('Select an account before importing receivables.');
  return `/receivables/tenants/${encodeURIComponent(tenantId)}`;
};
const options = () => {
  const viewAsUser = getSupportPreviewUserId(typeof window === 'undefined' ? '' : window.location.search);
  return viewAsUser ? { params: { viewAsUser } } : undefined;
};
const data = response => {
  if (response.data?.success !== true || !response.data.data) {
    throw new Error(response.data?.message || 'The receivables operation could not be confirmed.');
  }
  return response.data.data;
};

export const getReceivablesCapabilities = async tenantId => data(await getApiClient('company').get(`${base(tenantId)}/capabilities`, options()));
export const previewReceivablesImport = async (tenantId, request) => data(await getApiClient('company').post(`${base(tenantId)}/preview`, request, options()));
export const commitReceivablesImport = async (tenantId, request) => data(await getApiClient('company').post(`${base(tenantId)}/commit`, request, options()));
export const getReceivablesImport = async (tenantId, importId) => data(await getApiClient('company').get(`${base(tenantId)}/imports/${encodeURIComponent(importId)}`, options()));
export const getUnallocatedReceivables = async (tenantId, accountId) => {
  if (typeof accountId !== 'string' || !accountId.trim()) throw new Error('Enter the customer account ID to review unallocated transactions.');
  const config = options();
  return data(await getApiClient('company').get(`${base(tenantId)}/unallocated`, { ...config, params: { ...config?.params, accountId: accountId.trim() } }));
};
